import { useRef } from "react";
import { Paper, Typography, styled } from "@mui/material";
import dayjs from "dayjs";

const FooterContainer = styled(Paper)(({ theme }) => ({
  pt: 2.5,
  pb: 2.5,
  pr: 1.25,
  pl: 1.25,
  display: "flex",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  bottom: 0,
  [theme.breakpoints.down("md")]: {
    height: 48,
  },
  [theme.breakpoints.up("md")]: {
    height: 84,
  },
}));

const Footer = () => {
  const year = useRef(dayjs().get("year"));
  return (
    <FooterContainer component="footer" elevation={1}>
      <Typography variant="titleSmall">
        © {year.current} INFUSE All Rights Reserved
      </Typography>
    </FooterContainer>
  );
};

export default Footer;
